"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCalibration = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectCalibration = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectCalibration, _super);
    function IkeObjectCalibration() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.className = 'Calibration';
        _this.actionName = 'calibration';
        return _this;
    }
    return IkeObjectCalibration;
}(base_1.IkeRestObject));
exports.IkeObjectCalibration = IkeObjectCalibration;
//# sourceMappingURL=calibration.object.js.map